import { Injectable } from '@angular/core';
import { PersistenceService, StorageType } from 'angular-persistence';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { Constant } from '../../infrastructure/constant';
import { User } from '../../models/user.model';
import { BaseService } from '../base.service';
import { environment } from '../../../environments/environment';
import { ResponseModel } from '../../models';

@Injectable()
export class AuthService extends BaseService {

  constructor(protected persistenceService: PersistenceService, protected httpClient: HttpClient, private router: Router, private messageService: MessageService) {
    super(httpClient, persistenceService, environment.apiGeneralUrl, "Account");
  }

  public isLoggedIn(): boolean {
    var isLogged = this.persistenceService.get(Constant.auths.isLoginIn, StorageType.LOCAL);
    if (isLogged === 'true') {
      return true;
    }
    return false;
  }

  async login(userName: string, password: string): Promise<ResponseModel> {
    var loginObj = new Object();
    loginObj["UserName"] = userName;
    loginObj["PassWord"] = password;
    let ret = await super.postCustomApi("SignIn", loginObj).toPromise();
    return ret;
  }

  public logout() {
    this.persistenceService.remove(Constant.auths.isLoginIn, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.token, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.userId, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.userName, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.fullName, StorageType.LOCAL);
    var routing = Constant.pages.login.alias;
    this.router.navigate([routing]);
  }

  public getToken(): string {
    return this.persistenceService.get(Constant.auths.token, StorageType.LOCAL);
  }

  public getUserId(): number {
    return this.persistenceService.get(Constant.auths.userId, StorageType.LOCAL);
  }

  public getUserName(): string {
    return this.persistenceService.get(Constant.auths.userName, StorageType.LOCAL);
  }
  public getFullName(): string {
    return this.persistenceService.get(Constant.auths.fullName, StorageType.LOCAL);
  }
  public checkHourShift(userId: number, hourLogin: number, minuteLogin: number){
    var checkHourObj = new Object();
    checkHourObj["UserId"] = userId;
    checkHourObj["HourLogin"] = hourLogin;
    checkHourObj["MinuteLogin"] = minuteLogin;
    this.httpClient.post("api/Account/CheckHourShift", checkHourObj).subscribe((ret) => {
      console.log(ret);
      if (ret["isSuccess"] === 1) {      
      } else {
        this.logout();
        // this.messageService.add({severity:'warn', summary:'Đăng nhập không thành công', detail:'Đăng nhập không thành công.'});
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/services/auth/auth.service.ts